import api from "./api";
import { API_APPOINTMENTS_MOBILE_CONNECTIONS, API_MOBILE_CONNECTION_TEST } from "../constants/urls";


export const appointmentsMobileConnection = {
    getAll: async () => (await api.get(API_APPOINTMENTS_MOBILE_CONNECTIONS)).data,
    getById: async (id) => (await api.get(`${API_APPOINTMENTS_MOBILE_CONNECTIONS}/${id}`)).data,
    create: async (appointentsMobileConnection) => (await api.post(API_APPOINTMENTS_MOBILE_CONNECTIONS, appointentsMobileConnection)).data,
    update: async (appointentsMobileConnection) => (await api.put(`${API_APPOINTMENTS_MOBILE_CONNECTIONS}/${appointentsMobileConnection.id}`, appointentsMobileConnection)).data,
    delete: async (id) => (await api.delete(`${API_APPOINTMENTS_MOBILE_CONNECTIONS}/${id}`)).data,
    testConnection: async (appointentsMobileConnection) => (await api.post(`${API_APPOINTMENTS_MOBILE_CONNECTIONS}/${API_MOBILE_CONNECTION_TEST}`, appointentsMobileConnection)).data,
};
